const shuttleReports = {
  actions: {
    export: 'Exportieren',
  },

  table: {
    headers: {
      tripId: 'Fahrt-ID',
      routingType: 'Routing-Typ',
      reservationId: 'Reservierungs-ID',
      externalId: 'Externe ID',
      reservationStatus: 'Reservierungsstatus',
      tripStatus: 'Fahrtstatus',
      date: 'Datum',
      dateType: 'Datumstyp',
      passenger: 'Fahrgast',
      email: 'E-Mail',
      phone: 'Telefon',
      seats: 'Sitzplätze',
      supplier: 'Anbieter',
      shuttle: 'Shuttle',
      line: 'Linie',
      from: 'Von',
      to: 'Bis',
      driver: 'Fahrer',
      vehicle: 'Fahrzeug',
      paymentType: 'Bezahlarten',
      paymentDetails: 'Zahlungsdetails',
      profile: 'Profil',
      shuttleArea: 'Zone',
      dropOff: 'Absetzen',
      area: 'Zone',
      direction: 'Richtung',
      price: 'Preis',
      pickedTime: 'Ausgewählte Zeit',
      droppedTime: 'Ausstiegszeit',
      noshowTime: 'No-Show-Zeit',
      shuttleFare: 'Shuttle-Tarif',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'Neu',
          onhold: 'In der Warteschleife',
          cancelled: 'Storniert',
          routing: 'Routenplanung',
          routed: 'Geroutet',
          picked: 'Ausgewählt',
          dropped: 'Abgesetzt',
          noshow: 'No-Show',
        },
      },
    },

    filters: {
      reservationStatus: {
        options: {
          new: 'Neu',
          onhold: 'In der Warteschleife',
          cancelled: 'Storniert',
          routing: 'Routenplanung',
          routed: 'Geroutet',
          picked: 'Ausgewählt',
          dropped: 'Abgesetzt',
          noshow: 'No-Show',
        },
      },
      tripStatus: {
        options: {
          new: 'Neu',
          inroute: 'Unterwegs',
          sent: 'Gesendet',
          approved: 'Genehmigt',
          pickingUp: 'Abholung',
          done: 'Erledigt',
          cancelled: 'Storniert',
        },
      },
      routingType: {
        options: {
          bus: 'Bus',
          demand: 'Nachfrage',
          dynamic: 'Dynamisch',
        },
      },
    },
  },
  tableSummary: {
    title: 'Shuttle-Berichte',
    headers: {
      trips: 'Fahrten',
      reservations: 'Reservierungen',
      passengers: 'Fahrgäste',
      uniquePassengers: 'Bestimmte Fahrgäste',
    },
  },
};

export default shuttleReports;
